<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="">
                <div class="card-body">
                    <div class="container" *ngIf="lote?.id_estado === 3">
                        <div class="alert text-center py-4 shadow-sm">

                            <div class="mb-3 d-flex justify-content-center">
                                <lottie-player src="/assets/lottie/contractsign.json" background="transparent"
                                    speed="0.5" loop autoplay style="width:300px;height:300px"></lottie-player>
                            </div>

                            <h3 class="fw-bold">Sobre completado</h3>
                            <p class="mb-4">Este sobre ha sido completado.</p>

                            <button class="btn btn-primary rounded-pill px-4 py-2" (click)="volverInicio()">
                                <i class="fa-solid fa-house me-2"></i>
                                Volver al inicio
                            </button>

                        </div>
                    </div>
                    <app-stepper-component [steps]="3" [step]="stepActual" (stepChanged)="onStepChange($event)"
                        (onFinish)="guardar()"
                        [icons]="['fa-solid fa-plus','fa-solid fa-upload', 'fa-solid fa-users', 'fa-solid fa-arrow-pointer', 'fa-solid fa-pencil']"
                        [animation]="animationArray"
                        [nameStepers]="['Crear Sobre','Subida de Archivo','Participantes','Selección de Firma','Firma']"
                        *ngIf="userModule && lote?.id_estado != 3" [dato_evaluado]="'INC'"
                        [dato_evaluar]="short_estado_lote" [titulo_step]="titulo_step">
                      
                    </app-stepper-component>
                </div>

                <div class="container" *ngIf="!userModule">
                    <div class="alert text-center py-4 shadow-sm">

                        <div class="mb-3 d-flex justify-content-center">
                            <lottie-player src="/assets/lottie/wrong.json" background="transparent" speed="0.5" loop
                                autoplay style="width:300px;height:300px"></lottie-player>
                        </div>

                        <h3 class="fw-bold">Acceso limitado</h3>
                        <p class="mb-4">No tienes permisos para ver este recurso</p>

                        <button class="btn btn-primary rounded-pill px-4 py-2" (click)="volverInicio()">
                            <i class="fa-solid fa-house me-2"></i>
                            Volver al inicio
                        </button>

                    </div>
                </div>

            </div>
        </div>
    </div>